import { render, staticRenderFns } from "./digitalList.vue?vue&type=template&id=0098d16e&scoped=true&"
import script from "./digitalList.vue?vue&type=script&lang=js&"
export * from "./digitalList.vue?vue&type=script&lang=js&"
import style0 from "./digitalList.vue?vue&type=style&index=0&lang=css&"
import style1 from "./digitalList.vue?vue&type=style&index=1&id=0098d16e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0098d16e",
  null
  
)

export default component.exports